import React, { Component, useEffect } from 'react'
import { useLocation, withRouter } from 'react-router'
import queryString from 'query-string'

import withTranslation, { WithTranslation } from './hocs/withTranslation'
import { observer, inject } from 'mobx-react'
import { IStore } from '../store/models'
import { IUser } from '../store/models/User'
import AppLayout from './layout/AppLayout'
import ErrorBoundary from './shared/ErrorBoundary'
import { flow } from 'lodash'
import { useTranslation } from 'react-i18next'

const LocaleCheck = () => {
  const location = useLocation()
  const { i18n } = useTranslation()
  useEffect(() => {
    const query = queryString.parse(location?.search)
    if (i18n && query && query.locale) {
      try {
        const locale = typeof query.locale === 'string' ? query.locale : query.locale[0]
        locale && i18n.changeLanguage(locale)
      } catch {
        // ignore invalid locale in query params
      }
    }
  }, [i18n, location])

  return <></>
}

class AppContainer extends Component<Props & InjectedProps> {
  componentDidMount() {
    const {
        match,
        history,
        location,
        i18n: { changeLanguage },
        getLocationFromIP
      } = this.props,
      { search } = location,
      query = queryString.parse(search)

    getLocationFromIP()
  }

  componentDidUpdate(prevProps: Props & InjectedProps) {
    const { logged_in, redirectOnSuccess, history, setRedirectOnSuccess } = this.props

    if (logged_in && logged_in !== prevProps.logged_in && redirectOnSuccess) {
      setRedirectOnSuccess(undefined)
      history.push(redirectOnSuccess)
    }
  }

  render() {
    const { children } = this.props
    return (
      <AppLayout>
        <LocaleCheck />
        <ErrorBoundary>{children}</ErrorBoundary>
      </AppLayout>
    )
  }
}

interface Props extends WithTranslation {
  children: any
  history: any
  location: any
  match: any
}
interface InjectedProps {
  user?: IUser
  redirectOnSuccess?: string
  logged_in: boolean
  getLocationFromIP(): Promise<any>
  setRedirectOnSuccess(val?: string)
}

export default flow(
  withRouter,
  withTranslation,
  observer,
  inject<InjectedProps, Props>(({ mst }: { mst: IStore }, ownProps) => {
    const { auth } = mst
    return {
      user: auth.user,
      redirectOnSuccess: auth.redirectOnSuccess,
      logged_in: !!auth.user,
      getLocationFromIP: auth.getLocationFromIP,
      setRedirectOnSuccess: auth.setRedirectOnSuccess
    }
  })
)(AppContainer)
